<template>
    <div class="ServiceDetail">
        <RouteHeadAndCrumbs
            :backgroundImg="backgroundImg"
            :breadcrumbsInfo="breadcrumbsInfo"
        />
        <div class="service-detail-container">
            <p class="service-detail-title">{{ serverInfo.title }}</p>
            <div
                v-html="serverInfo.content"
                class="service-detail-content-container"
            >

            </div>
        </div>
    </div>
</template>

<script>
import headImg from "../assets/images/joinUs.png";

import { ROUTEINFO } from "../utils/constant";

import { GETSERVERINFOBYID } from "../utils/uriList";

export default {
    mounted() {
        this.getServerInfoById();
    },
    data() {
        return {
            backgroundImg: headImg,
            breadcrumbsInfo: [
                {
                    routeName: ROUTEINFO.home.name,
                    routeLabel: "首页",
                    routeTo: {
                        path: ROUTEINFO.home.path,
                    },
                },
                {
                    routeName: ROUTEINFO.productService.name,
                    routeLabel: "产品与服务",
                    routeTo: {
                        path: ROUTEINFO.productService.path,
                    },
                },
                {
                    routeName: ROUTEINFO.productDetail.name,
                    routeLabel: "伦伟服务",
                },
            ],
            serverInfo: {},
        };
    },
    methods: {
        async getServerInfoById() {
            const response = await this.$http.get(GETSERVERINFOBYID, {
                params: {
                    id: this.$route.params.serviceId,
                },
            });
            if (response.data.code === 0) {
                this.serverInfo = response.data.data;
            }
        },
    },
};
</script>

<style lang="scss" >
@import "../assets/scss/views/ServiceDetail.scss";
</style>
